const mapDocuments = (document, {documentId, value}) => {
	if (document.documentId === documentId) return {...document, documentName: value};
	return document;
};

const mapInstructions = (instruction, payload) => {
	const {documents, ...rest} = instruction;
	return {
		...rest,
		documents: documents.map((document) => mapDocuments(document, payload))
	};
};

const mapSections = (section, payload) => {
	const {instructions, ...rest} = section;
	return {
		...rest,
		instructions: instructions.map((instruction) => mapInstructions(instruction, payload))
	};
};

export const normalizeRenameDocument = (state, {isTask, ...rest}) => {
	return isTask
		? {...state, tasks: state.tasks.map((task) => mapInstructions(task, rest))}
		: state.map((section) => mapSections(section, rest));
};

export const normalizeDeleteDocument = (state, {isTask, documentId}) => {
	const filterDocuments = (doc) => doc.documentId !== documentId;
	if (isTask) {
		return {
			...state,
			tasks: state.tasks.map((task) => ({
				...task,
				documents: task.documents.filter(filterDocuments)
			}))
		};
	}
	return state.map((section) => ({
		...section,
		instructions: section.instructions.map((instruction) => ({
			...instruction,
			documents: instruction.documents.filter(filterDocuments)
		}))
	}));
};
